
import CalendarComponent from './components/calendar.js'
import AgendaComponent from './components/agenda.js'

var calendar, agenda

export function initCalendar(): void {
    calendar = new CalendarComponent({el: '#monthlyview'}, {parse: true})
    agenda = new AgendaComponent({el: '#weeklyview'}, {parse: true})

    $('#weekly-btn').click(() => {
        calendar.hide();
        agenda.show();
    })
    $('#monthly-btn').click(() => {
        agenda.hide();
        calendar.show();
    })

    calendar.hide()
    agenda.show()
}

export function goMonth(n:number) {
    calendar.goMonth(n);
}
